import { render, staticRenderFns } from "./XlsList.vue?vue&type=template&id=e2a73b7e"
import script from "./XlsList.vue?vue&type=script&lang=js"
export * from "./XlsList.vue?vue&type=script&lang=js"
import style0 from "./XlsList.vue?vue&type=style&index=0&id=e2a73b7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports